import React, { useState, useMemo } from 'react'
import './Skills.css'
import { Container } from 'react-bootstrap'
import { 
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiDocker,
  SiKubernetes,
  SiAdobe,
  SiReact,
  SiMysql,
  SiNodedotjs,
  SiApache,
  SiApachemaven,
  SiAmazonaws,
  SiOpenjdk,
  SiGit,
  SiSonarqube,
  SiEslint,
  SiJira
} from 'react-icons/si'

const allSkills = [
  { name: 'Adobe Experience Manager', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Adobe Workfront', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Adobe Workfront Fusion', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Adobe Analytics', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Adobe App Builder', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Adobe Target', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Content Management', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Multi-Site Manager', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },
  { name: 'Asset Management', Icon: SiAdobe, category: 'adobe', brandColor: '#FF0000' },

  { name: 'React', Icon: SiReact, category: 'frontend', brandColor: '#61DAFB' },
  { name: 'JavaScript', Icon: SiJavascript, category: 'frontend', brandColor: '#F7DF1E' },
  { name: 'HTML5', Icon: SiHtml5, category: 'frontend', brandColor: '#E34F26' },
  { name: 'CSS3', Icon: SiCss3, category: 'frontend', brandColor: '#1572B6' },

  { name: 'Java', Icon: SiOpenjdk, category: 'backend', brandColor: '#EA2D2E' },
  { name: 'Node.js', Icon: SiNodedotjs, category: 'backend', brandColor: '#339933' },
  { name: 'Apache Sling', Icon: SiApache, category: 'backend', brandColor: '#D22128' },
  { name: 'OSGi', Icon: SiApache, category: 'backend', brandColor: '#D22128' },
  { name: 'Apache HTTP Server', Icon: SiApache, category: 'backend', brandColor: '#D22128' },
  { name: 'MySQL', Icon: SiMysql, category: 'backend', brandColor: '#4479A1' },
  { name: 'RESTful APIs', Icon: SiApache, category: 'backend', brandColor: '#6366F1' },

  { name: 'Amazon Web Services', Icon: SiAmazonaws, category: 'cloud', brandColor: '#FF9900' },
  { name: 'Docker', Icon: SiDocker, category: 'cloud', brandColor: '#2496ED' },
  { name: 'Kubernetes', Icon: SiKubernetes, category: 'cloud', brandColor: '#326CE5' },
  { name: 'Maven', Icon: SiApachemaven, category: 'cloud', brandColor: '#C71A36' },
  { name: 'Git', Icon: SiGit, category: 'cloud', brandColor: '#F05032' },
  { name: 'SonarQube', Icon: SiSonarqube, category: 'cloud', brandColor: '#4E9BCD' },
  { name: 'ESLint', Icon: SiEslint, category: 'cloud', brandColor: '#4B32C3' },
  { name: 'JIRA', Icon: SiJira, category: 'cloud', brandColor: '#0052CC' }
]

const categories = [
  { id: 'all', label: 'All Skills' },
  { id: 'adobe', label: 'Adobe & CMS' },
  { id: 'frontend', label: 'Frontend' },
  { id: 'backend', label: 'Backend & APIs' },
  { id: 'cloud', label: 'Cloud & DevOps' }
]

const SkillChip = ({ name, Icon, brandColor }) => {
  return (
    <li
      className="skill-chip"
      aria-label={name}
      style={{ '--skill-brand': brandColor }}
    >
      <span className="skill-icon" aria-hidden="true">
        <Icon />
      </span>
      <span className="skill-label">{name}</span>
    </li>
  )
}

function Skills() {
  const [activeCategory, setActiveCategory] = useState('all')

  const filteredSkills = useMemo(() => {
    if (activeCategory === 'all') return allSkills
    return allSkills.filter(s => s.category === activeCategory)
  }, [activeCategory])

  return (
    <div className="section-container">
      <Container>
        <h2 className="section-title">Professional Skills</h2>

        {/* Category Filter Pills */}
        <div className="skills-filter-container">
          {categories.map(cat => (
            <button
              key={cat.id}
              type="button"
              className={`skills-filter-pill ${activeCategory === cat.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat.id)}
              aria-pressed={activeCategory === cat.id}
            >
              {cat.label}
              {activeCategory === cat.id && (
                <span className="filter-count">({filteredSkills.length})</span>
              )}
            </button>
          ))}
        </div>

        {/* Skills Grid */}
        <ul className="skills-grid">
          {filteredSkills.map(skill => (
            <SkillChip
              key={skill.name}
              name={skill.name}
              Icon={skill.Icon}
              brandColor={skill.brandColor}
            />
          ))}
        </ul>
      </Container>
    </div>
  )
}

export default Skills
